module.exports = __webpack_public_path__ + "01_medium_brown.95906256.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_medium_brown.png
// module id = 9nQd
// module chunks = 0